import { Button, Grid, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import { Asset, Property, WorkOrderUpdateInput } from 'vendor-marketplace-shared-library';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import PrimaryButton from '../../../components/common/styled-mui-overrides/PrimaryButton';
import SecondaryButton from '../../../components/common/styled-mui-overrides/SecondaryButton';
import { UpdateWorkOrderFormData } from '../CreateWorkOrderFormPage';
import { DropdownWithCheckboxes } from '../../../components/common/DropdownWithCheckboxes';

type CreateWorkOrderWhereProps = {
  workOrderId: string;
  formData: Partial<UpdateWorkOrderFormData>;
  setFormData: (data: Partial<UpdateWorkOrderFormData>) => void;
  properties: Property[];
  assets: Asset[];
  onSubmit: (data: Partial<WorkOrderUpdateInput>) => void;
};

export default function CreateWorkOrderWhere(props: CreateWorkOrderWhereProps) {
  const navigate = useNavigate();
  const [selectedAssetIds, setSelectedAssetIds] = React.useState<string[]>([]);
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  return (
    <Grid container spacing={2} sx={styles.mainContainer}>
      <Grid item xs={0} md={3}></Grid>
      <Grid item container xs={12} md={6} spacing={2} sx={styles.center}>
        <Grid item xs={12}>
          <InputLabel>Property</InputLabel>
          <Select
            name={'propertyId'}
            value={props.formData.propertyId}
            onChange={e => props.setFormData({ ...props.formData, propertyId: e.target.value })}
            fullWidth
          >
            {props.properties.map((property: Property) => (
              <MenuItem key={property.id} value={property.id}>
                {property.name}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        {props.assets.length > 0 && (
          <Grid item xs={12}>
            <InputLabel>Asset</InputLabel>
            <Button onClick={(e: React.MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget)}>
              Select assets
            </Button>
            <DropdownWithCheckboxes
              entities={props.assets}
              onClose={() => {
                setAnchorEl(null);
                props.setFormData({ ...props.formData, workOrderAssetIds: selectedAssetIds });
              }}
              onSave={() => {}}
              anchorEl={anchorEl}
              selectedIds={selectedAssetIds}
              setSelectedIds={setSelectedAssetIds}
              displayFieldKey={'make'}
            />
          </Grid>
        )}

        {props.formData.workOrderAssetIds && props.formData.workOrderAssetIds.length > 0 && (
          <Grid item xs={12}>
            <Grid item>
              <Typography color={'secondary.main'}>Selected Assets:</Typography>
            </Grid>
            {props.assets
              .filter(asset => props.formData.workOrderAssetIds?.includes(asset.id))
              .map(asset => (
                <Grid item xs={12} key={asset.id}>
                  <Typography variant={'caption'}>{`${asset.make}-${asset.model}`}</Typography>
                </Grid>
              ))}
          </Grid>
        )}

        <Grid item xs={12}>
          <InputLabel>Unit, building, or other</InputLabel>
          <TextField
            value={props.formData.propertyLocation}
            onChange={e =>
              props.setFormData({ ...props.formData, propertyLocation: e.target.value })
            }
            placeholder={'Unit A'}
            multiline
            fullWidth
          />
        </Grid>
        <Grid item>
          <SecondaryButton
            onClick={() => navigate(`/create-work-order/${props.workOrderId}/?step=1`)}
          >
            Back
          </SecondaryButton>
        </Grid>
        <Grid item>
          <PrimaryButton
            onClick={() => {
              props.onSubmit;
              navigate(`/create-work-order/${props.workOrderId}/?step=3`);
            }}
          >
            Next
          </PrimaryButton>
        </Grid>
      </Grid>
      <Grid item xs={0} md={3}></Grid>
    </Grid>
  );
}

const styles = {
  mainContainer: {
    justifyContent: 'center',
    paddingTop: 4,
  },
  center: {
    justifyContent: 'center',
  },
};
